export const SurveyFormFieldNames = {
  Name: 'name',
  Code: 'code',
  Description: 'description',
  ContextId: 'contextId',
  BranchId: 'branchId',
  IsActive: 'isActive',
} as const;

export type SurveyFormFieldName = typeof SurveyFormFieldNames[keyof typeof SurveyFormFieldNames];
